import { BRAND_COLORS, SHADOWS, GRAY_COLORS } from '../globalTheme';

export const theme = {
	sidebar: {
		height: '100vh',
		borderRight: `1px solid #F0F0F0`,
		overflowY: 'auto' as const
	},
	sidebarToggle: {
		width: '100%',
		height: '64px',
		padding: '16px 12px 16px 20px',
		gap: '10px',
		borderBottom: `1px solid #F0F0F0`
	},
	collapsedSidebar: {
		width: '56px'
	},
	sidebarSection: {
		padding: '10px',
		gap: '12px',
		height: '40px'
	},
	sidebarSectionHover: {
		color: BRAND_COLORS.brand700
	},
	activeItem: {
		background: BRAND_COLORS.brand50,
		color: BRAND_COLORS.brand700
	},
	sectionOpen: {
		color: BRAND_COLORS.brand700,
		border: `1px solid ${BRAND_COLORS.brand50}`
	},
	sectionItem: {
		padding: '8px 12px',
		cursor: 'pointer',
		fontSize: '12px'
	},
	sectionItemHover: {
		background: BRAND_COLORS.brand50
	},
	logoutSectionContent: {
		background: 'white',
		cursor: 'pointer',
		boxShadow: SHADOWS.lg,
		width: '180px',
		border: `1px solid ${GRAY_COLORS.gray50}`,
		borderRadius: '4px'
	}
};

export type Theme = typeof theme;
